import { ContainerComponent, wrap } from 'AppReact';
import React from 'react';
import {
  CustomWidthHeight, AbsolutePositionWrapper,
  FlexCenterWrapper, FullSizeRelativeWrapper,
  Ml6, Width150
} from 'wrappers';
import internalState from './internalState';
import Controller from './controller';
import MapZoom from '../mapZoom';
import Dropdown from '../dropdown';
import { getIsMobile } from 'utils';
import { ClickableIcon } from 'atoms';
import { ResizeSvg } from 'components/icons';

const isMobile = getIsMobile()

const containerRef = React.createRef();

export const definition = {
  name: 'UnitMap',
  controller: Controller,
  initialProps: ({ mapId }) => ({
    mapId,
    containerRef
  }),
  props: internalState,
  elements: [
    {
      wrapper: CustomWidthHeight,
      name: 'MapWrapper',
      displayState: ({ }) => ({ width: '100%', height: '100%' }),
      renderIf: ({ containerRef }) => !!containerRef,
      ref: containerRef,
      elements: [
      ]
    },
    {
      wrapper: AbsolutePositionWrapper,
      name: 'Wrapper',
      displayState: ({ }) => ({ left: "10px", top: '12px' }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: '__transparent__',
          elements: [
            {
              component: MapZoom,
              renderIf: ({ }) => !isMobile,
              name: 'MapZoom',
              bindings: ({ zoom, map }) => ({ zoom, map })
            },
            {
              component: isMobile ? wrap(Dropdown, Width150) : wrap(wrap(Dropdown, Width150), Ml6),
              name: 'Dropdown',
              renderIf: ({ floorsList }) => floorsList.length > 1,
              bindings: ({ selectedFloorId, map, floorsList }) => {
                return ({ label: ' ', selectedOptionId: selectedFloorId, options: floorsList, map, height: '46px', search: true, enableFullWidth: true })
              }
            },
            {
              component: wrap(ClickableIcon, Ml6),
              name: 'Reset',
              renderIf: ({ }) => isMobile,
              bindings: ({ map }) => ({ map }),
              displayValue: ({ }) => ResizeSvg({ width: 40, height: 40 })
            }
          ]
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), FullSizeRelativeWrapper);
